import Vue from 'vue'
import Vuex from'vuex'
import Getters from './getters.js'
import user from './modules/user.js'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
	namespace: true,
	modules: {
		user
	},
	Getters,
	plugins:[
		createPersistedState()
	]
})



